<template>
  <div class="activated-stations">
    <div class="activated-station__desc mrgr">
      <h3 class="mrg0 mrgb">
        {{ $t('courseConnection.activated-stations-title') }}
      </h3>
      <p class="mrg0">
        {{ $t('courseConnection.activated-stations-text') }}
      </p>
    </div>
    <div class="activated-stations__list">
      <Chip
        v-for="station in Object.values(courseConnectionsLocations)"
        :key="station.id"
        closable
        @close="() => openStationDisablingDialog(station)"
      >
        {{ station.name }}
      </Chip>
    </div>
    <Btn
      data-cy="add-contact"
      variant="primary"
      class="mrgl button-add"
      @click="toggleAdd"
    >
      <Icon id="add"></Icon>
      {{ $t('common.add') }}
    </Btn>
  </div>
</template>

<script>
import Chip from '@/components/ui/Chip.vue';
import eventBus from '@/eventBus';
import { mapState } from 'vuex';

export default {
  components: { Chip },
  computed: {
    ...mapState('courses', ['courseConnectionsLocations']),
  },
  methods: {
    toggleAdd() {
      eventBus.$emit('toggleStationActivationDialog');
    },
    openStationDisablingDialog(station) {
      eventBus.$emit('toggleStationDisablingDialog', station);
    },
  },
};
</script>

<style lang="scss">
.activated-stations {
  background-color: $alt-50;
  border-radius: 4px;
  border: 1px solid $alt-200;
  padding: $spacing-unit-default;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__list {
    display: flex;
    flex-wrap: wrap;
    gap: $spacing-unit-small;
  }
}

.activated-station__desc {
  min-width: 12em;
}

.button-add {
  min-width: 8em;
}
</style>
